module.exports = __webpack_public_path__ + "img/cloud-2.01335fbd.png";